import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const testimonials = [
  {
    quote:
      "I came to Mandie thinking I needed strategies to manage better. What I found was a version of myself I had buried so long ago I had forgotten she existed. I stopped apologising for taking up space. I started saying no, and meaning it. I am not the same woman. I do not want to be.",
    name: 'Sarah M.',
    program: '1:1 Coaching',
  },
  {
    quote:
      "I had been in therapy for six years. I thought I had done the work. The H.O.M.E showed me the layer underneath all of that, the part of me that still did not believe she deserved to take up space. That part healed. This is not a programme. It is a homecoming.",
    name: 'Jessica K.',
    program: 'HOME Alumni',
  },

];

export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const cardsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        headerRef.current,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 70%',
          },
        }
      );
      if (cardsRef.current) {
        const cardEls = cardsRef.current.children;
        gsap.fromTo(
          cardEls,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.15,
            scrollTrigger: {
              trigger: cardsRef.current,
              start: 'top 80%',
            },
          }
        );
      }
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-[#6B1E3B] py-16 md:py-28 lg:py-32"
    >
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        {/* Header */}
        <div ref={headerRef} className="text-center mb-14">
          <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-6">
            What the women say
          </p>
          <h2 className="font-heading text-xl md:text-3xl lg:text-5xl leading-[1.2] text-[#FDFAF8]">
            Mandie will take you somewhere
            <br />
            you cannot go alone.
          </h2>
        </div>

        {/* Gold Divider */}
        <div className="w-16 h-px bg-[#C9A84C] mx-auto mb-14" />

        {/* Testimonial Cards */}
        <div
          ref={cardsRef}
          className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto"
        >
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="bg-[#4A1430]/40 border border-[#3A1030]/30 p-5 md:p-8 flex flex-col"
            >
              <p className="font-quote text-base md:text-lg italic text-[#F8EDF2] leading-relaxed mb-6 flex-grow">
                {item.quote}
              </p>
              <div>
                <p className="font-body text-sm font-medium text-[#C9A84C]">
                  {item.name}
                </p>
                <p className="font-body text-xs text-[#C8B8C0] mt-1">
                  {item.program}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}